// externals
import styled from 'styled-components';

// libraries
import { Card } from '@interstate/components/Card';
import { BreakPoint } from '@makemydeal/dr-activities-common';

type VehicleListRowItemContainerProps = {
    selected?: boolean;
    isCompact?: boolean;
};

export const VehicleListRowItemContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const VehicleListRowItemContainer = styled(Card)<VehicleListRowItemContainerProps>`
    && {
        border-left: ${({ selected, theme }) => (selected ? `4px solid ${theme.tokens.BaseColorBlue900}` : '')};
        background-color: ${({ selected, theme }) => (selected ? theme.tokens.BaseColorBlue50 : '')};
    }
    &.vehicle-list-item-compact-ui {
        border-radius: 0px !important;
    }
`;

// Off-screen but still in the accessibility tree, so a screen reader announces its text. `display: none` and
// `visibility: hidden` would drop it from that tree, which is the one thing a live region cannot afford.
export const VehicleListRowItemVisuallyHiddenStatus = styled.span`
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
`;

export const VehicleListRowItemNotInStockContent = styled.div`
    display: flex;
    flex-direction: row;
    gap: 9px;
    align-items: flex-start;

    @container (width < ${BreakPoint.PHONE}) {
        flex-direction: column;
    }
`;

export const VehicleListRowNotInStockInfoContainer = styled.div`
    flex-grow: 1;
`;

export const VehicleListRowImageContainer = styled.div<VehicleListRowItemContainerProps>`
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: 150px;
    max-width: 150px;
    height: 101px;
    overflow: hidden;
    display: flex;

    @container (width < ${BreakPoint.PHONE}) {
        align-self: center;
    }
`;

export const VehicleListRowImageContainerCompact = styled(VehicleListRowImageContainer)`
    width: 70px;
    max-width: 70px;
    height: 47px;
`;
